import { Component, OnInit, TemplateRef } from '@angular/core';
import { CourtNameService } from './courtname.service';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CourtService } from '../court/court.service';
import { CourtName } from './courtname';
import { ToastrService } from 'ngx-toastr';
import { CommondialogComponent } from '../../../app/Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-courtname',
  templateUrl: './courtname.component.html',
  styleUrls: ['./courtname.component.css']
})
export class CourtnameComponent implements OnInit {

  courtNameList = [];
  itemsPerPage = 10;
  p = 1;
  reverse = false;
  key = 'courtname';
  sendPageName: string = 'Court Name Master';
  searchText: string;
  courtNameModalRef: BsModalRef;
  courtNameForm: FormGroup;
  operation = '';
  courtDDSettings: any;
  courtList = [];
  userid: number;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true,
  };
  showall = true;
  courtNameListDetails = [];
  _menuId: any;
  _actionRights: any;
  sendMenuId: number;
  readOnly = false;
  add: boolean = false;
  edit: boolean = false;
  delete: boolean = false;
  submitShow: boolean = false;
  listColumn = [
    { label: '#', value: '' },
    { label: 'Action', value: '' },
    { label: 'Incoming Court Name', value: 'courtname' },
    { label: 'Court Master Mapping', value: 'courtmastername' }

  ];

  constructor(
    private courtNameService: CourtNameService,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private courtservice: CourtService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private spinnerService: NgxSpinnerService,
    private router: Router,
    private localService: LocalService
  ) {

    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Court_name_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Court_name_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined) {
        this._menuId = localStorage.getItem('Court_name_menuid');
        this.sendMenuId = this._menuId;
      }

      if (this._actionRights == undefined) {
        this._actionRights = localStorage.getItem('Court_name_action');
      }
    }

  }

  ngOnInit() {
    this.checkIsMenuMapped();
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    this.createForm();
    // this.getAllCourtName();
    // this.getCourtDD();
    this.get();
    this.getActionRightsList();
  }

  createForm() {
    this.courtNameForm = this.fb.group({
      courtName: ['', Validators.required],
      courtNameId: [0],
      courtId: [0, [Validators.required, Validators.min(0.1)]],
      active: [0]
    });
  }


  get() {
    this.spinnerService.show();
    Promise.all([this.courtNameService.getAll().toPromise(), this.courtservice.Get().toPromise()]).then(
      ([courtNameRes, courtRes]) => {
        let courtMasterResponse: any[] = courtRes;
        let list = [];
        courtMasterResponse.forEach(element => {
          list.push({
            id: element.courtid,
            name: element.court
          });
        });
        this.courtList = list;

        let courtNameList: any[] = courtNameRes;
        courtNameList.forEach(element => {
          element['courtmastername'] = this.getcourtMasterName(element.courtid);
        });
        this.courtNameList = courtNameList;
        this.courtNameListDetails = JSON.parse(JSON.stringify(this.courtNameList));
        this.spinnerService.hide();
      });
  }

  getcourtMasterName(id) {
    let courtValue = this.courtList.filter(x => x.id == id);
    if (courtValue.length > 0) {
      return courtValue[0].name;
    } else {
      return '';
    }
  }




  getAllCourtName() {
    
    this.courtNameService.getAll().subscribe(courtNameRes => {
      this.courtNameList = courtNameRes;
    });
  }

  onsubmit(formValue) {
    this.spinnerService.show();
    if (this.operation == 'add') {
      let postModel = new CourtName();
      postModel.courtid = formValue.courtId;
      postModel.courtname = formValue.courtName.trim();
      postModel.createdby = this.userid;
      postModel.courtnameid = formValue.courtNameId;
      postModel.active = formValue.active;
      this.courtNameService.post(postModel).subscribe(res => {
        if (res.body != 0) {
          this.courtNameModalRef.hide();
          // this.getAllCourtName();
          this.get();
          this.toastr.success('Data added successfully');
        } else {
          this.toastr.warning('Record already exists.');
        }
        this.spinnerService.hide();
      }, err => {
        this.toastr.error('Data is not added');
        this.spinnerService.hide();
      });

    } else {
      let putModel = new CourtName();
      putModel.courtid = formValue.courtId;
      putModel.courtname = formValue.courtName.trim();
      putModel.modifiedby = this.userid;
      putModel.courtnameid = formValue.courtNameId;
      putModel.active = formValue.active;
      this.courtNameService.put(putModel).subscribe(res => {
        if (res.body != 0) {
          this.courtNameModalRef.hide();
          // this.getAllCourtName();
          this.get();
          this.toastr.success('Data Edited successfully');
        } else {
          this.toastr.warning('Record already exists.');
        }
        this.spinnerService.hide();
      }, err => {
        this.toastr.error('Data is not edited');
        this.spinnerService.hide();
      });
    }
  }

  openCourtNameModal(template: TemplateRef<any>, type, id) {
    
    this.operation = type;
    if (type == 'add') {
      this.courtNameForm.patchValue({
        courtName: '',
        courtNameId: 0,
        courtId: 0,
        active: 0
      });
    } else {
      let editValue = this.courtNameList.filter(x => x.courtnameid == id);
      if (editValue.length > 0) {
        let patchValue = editValue[0];
        this.courtNameForm.patchValue({
          courtName: patchValue.courtname,
          courtNameId: patchValue.courtnameid,
          courtId: patchValue.courtid,
          active: patchValue.active
        });
      }
    }

    this.courtNameModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove('modal-content');
  }

  clearForm() {
    this.courtNameForm.patchValue({
      courtName: '',
      courtNameId: 0,
      courtId: 0,
    });
  }

  getCourtDD() {
    this.courtservice.Get().subscribe(courtRes => {
      let courtMasterResponse = courtRes;
      let list = [];
      courtMasterResponse.forEach(element => {
        list.push({
          id: element.courtid,
          name: element.court
        });
      });
      this.courtList = list;
    });
  }

  openConfirmTemplate(court, template: TemplateRef<any>) {
    let confmsg = '';
    if (court.active == 0) {
      confmsg = 'activate';
    } else {
      confmsg = 'deactivate';
    }
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.activeOrDeactive(court);
        }
      });

  }

  activeOrDeactive(court) {
    this.spinnerService.show();
    var msg;
    if (court.active == 0) {
      court.active = 1;
      msg = 'Record activated successfully';
    }
    else {
      court.active = 0;
      msg = 'Record deactivated successfully';
    }
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    court.modifiedby = this.userid;
    this.courtNameService.delete(court).subscribe(res => {
      this.toastr.success(msg);
      // this.getAllCourtName();
      this.get();
      this.spinnerService.hide();
    }, error => {

    });

  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }


  getactiveinactive(showallp) {
    this.showall = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.courtNameList = [];
      this.courtNameList = this.courtNameListDetails.filter(x => x.active == 1);
    } else {
      this.showall = true;
      this.courtNameList = [];
      this.courtNameList = this.courtNameListDetails;
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedcourtname");
    let data = arrays.find(ob => ob['name'] === 'Court Name Master');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedcourtname","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedcourtname",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1) {
            this.readOnly = true;
          }
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }




}
